/**
 * UserInfoBar.js
 * Talkroute
 *
 * Created by Vel Genov on 12/8/18
 * Copyright (c) 2018 Talkroute. All right reserved.
 */

import React from "react";
import { connect } from "react-redux";
import { Grid, Dropdown } from "semantic-ui-react";

import userConstants from "@constants/userConstants";
import { domIds } from "@constants/testConstants";
import uiString from "@constants/uiString";

import { logout } from "@actions/userActions";

import UserStatus from "./UserStatus";
import ChevronIcon from "@resources/icons/filter-chevron.svg";
import { AuthContext } from "../context/AuthProvider";

interface IUserInfoBarProps {
  firstName: string;
  lastName: string;
  companyName: string;
  logout: () => any;
}

/**
 * Shows basic user info and logout controls
 */
class UserInfoBar extends React.Component<IUserInfoBarProps, any> {
  static defaultProps = {
    firstName: "",
    lastName: "",
    companyName: "",
  };

  /**
   * Called to handle a user logout
   */
  handleLogout = () => {
    const { logout: logoutLocal } = this.props;

    // Dispatch a logout action
    // logoutLocal && logoutLocal();
    this.context.logout();
  };

  /**
   * Truncates the user name if its length exceeds the limit
   */
  formatUserName = (userName) => {
    if (userName.length > userConstants.USER_NAME_LEN) {
      const truncatedUserName = userName.substring(
        0,
        userConstants.USER_NAME_LEN
      );
      return `${truncatedUserName}...`;
    }

    return userName;
  };

  /**
   * Lifecycle function, called when the component is mounted to do additional setup
   */
  componentDidMount() {}

  render() {
    const { firstName, lastName, companyName } = this.props;
    const callStatus = uiString.callStatus.ONLINE;
    const userName = `${firstName} ${lastName}`;

    return (
      <Grid style={{ margin: "0px" }}>
        <Grid.Row style={{ padding: "2em 1em 1em 1em" }}>
          <h2
            id={domIds.COMPANY_NAME_LINE}
            style={{
              display: "inline",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            className="none-select-text"
          >
            {companyName}
          </h2>
        </Grid.Row>
        <Grid.Row style={{ paddingLeft: "1em", alignItems: "center" }}>
          <UserStatus status={callStatus} />
          <Dropdown
            id={domIds.USER_NAME_LINE}
            text={this.formatUserName(userName)}
            className="text-large"
            icon={<ChevronIcon className="dropdown-icon"/>}
            style={{
              padding: "0 10px",
              lineHeight: "1em",
              maxWidth: "220px",
            }}
          >
            <Dropdown.Menu>
              <Dropdown.Item
                id={domIds.USER_INFO_BAR_LOGOUT_BUTTON}
                text={uiString.LOGOUT}
                onClick={this.handleLogout}
              />
            </Dropdown.Menu>
          </Dropdown>
        </Grid.Row>
      </Grid>
    );
  }
}

// Redux data binding
const mapStateToProps = (state) => ({
  firstName: state.authentication.firstName,
  lastName: state.authentication.lastName,
  companyName: state.authentication.companyName,
});

UserInfoBar.contextType = AuthContext
export default connect(mapStateToProps, { logout })(UserInfoBar);
